import React, { useState, useCallback, useEffect } from "react";
import { Image } from "@chakra-ui/react";
import { getCasinoLastTenResultsTunnelAPI } from "../../service/casino";
import { useSelector } from "react-redux";

const suitImages = {
  S: require("../../assets/img/casino/spade.png"),
  H: require("../../assets/img/casino/heart.png"),
  D: require("../../assets/img/casino/diamond.png"),
  C: require("../../assets/img/casino/club.png"),
};

// Map backend selection ID → display label per game.
// Dragon Tiger: "1" = Dragon, "2" = Tiger, "3" = Tie
const WINNER_LABEL_MAP = {
  "1": "D",
  "2": "T",
  "3": "Tie",
};

const LastResults = ({ isImage, eventId, setIsResultModalOpen }) => {
  const userData = useSelector((state) => state.account.userData);
  const [lastTenResult, setLastTenResult] = useState([]);

  const getCasinoLastResults = useCallback(async () => {
    try {
      const response = await getCasinoLastTenResultsTunnelAPI(eventId);
      // Tunnel API may wrap data at varying depths — walk until we find an array
      const d = response?.data ?? response;
      const unwrap = (obj) => {
        if (Array.isArray(obj)) return obj;
        if (obj && typeof obj === "object" && obj.data != null) return unwrap(obj.data);
        return [];
      };
      setLastTenResult(unwrap(d));
    } catch (error) {
      // Silently fail — polling will retry
    }
  }, [eventId]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    let interval;
    if (token) {
      getCasinoLastResults();
      interval = setInterval(getCasinoLastResults, 5000);
    }
    return () => clearInterval(interval);
  }, [getCasinoLastResults, eventId]);

  return (
    <>
      <div className="fancy-marker-title">
        <h4>
          Last Result{" "}
          <a href="#" className="result-view-all">
            View All
          </a>
        </h4>
      </div>
      <div className="m-b-10">
        <p id="last-result" className="text-right">
          {lastTenResult?.map((result, idx) => {
            const label = WINNER_LABEL_MAP[result.win] || result.win;
            return (
              <span key={result.mid || idx}>
                <span
                  className={`ball-runs last-result ${
                    label === "D"
                      ? "playera"
                      : label === "T"
                      ? "playerb"
                      : ""
                  }`}
                >
                  {eventId === "RACE20" ? (
                    <Image src={suitImages[label]} />
                  ) : (
                    label
                  )}
                </span>
              </span>
            );
          })}
        </p>
      </div>
    </>
  );
};

export default LastResults;
